import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

export function serialize(record) {
  return JSON.stringify(record);
}

export function deserialize(json) {
  let {
    additional_dues                        : additionalDues = [],
    advice                                 : advice = [],
    budget_classification                  : budgetClassification = [],
    certification                          : certification = [],
    certification_types                    : certification_types = [],
    classification_certificate             : classificationCertificate = [],
    preliminary_classification_certificate : preliminaryClassificationCertificate = [],
    features_of_customs_clearance          : featuresOfCustomsClearance = [],
    code                                   : code = '',
    comments                               : comments = [],
    notes                                  : notes = [],
    classification_comments                : classification_comments = [],
    customs_laboratoris                    : customsLaboratoris = [],
    description                            : description = [],
    dual_use_goods                         : dualUseGoods = [],
    duty                                   : duty = [],
    free_trade_zone_agreements             : free_trade_zone_agreements = [],
    duty_sng                               : duty_sng = [],
    excise_dues                            : exciseDues = [],
    excise_duty_marks                      : exciseDutyMarks = [],
    export_dues                            : exportDues = [],
    export_dues_adjust                     : exportDuesAdjust = [],
    filling_instruction                    : fillingInstruction = [],
    licence                                : licence = [],
    ondate                                 : ondate = '',
    quota                                  : quota = [],
    short_description                      : shortDescription = '',
    tariff_preference                      : tariffPreference = [],
    unit_name                              : unitName = [],
    vat                                    : vat = [],
    to_date                                : to_date = null,
    id                                     : id = 0,
    parent                                 : parent = 0,
    tnved                                  : tnved = [],
    code14                                 : code14 = [],
    direction                              : direction = 0,
    intellectual                           : intellectual = [],
    parallel_import                        : parallel_import = [],
  } = compactJson(json);

  ondate = moment(ondate, DATE_FORMAT);

  return {
    additionalDues,
    advice,
    budgetClassification,
    certification,
    certification_types,
    classificationCertificate,
    preliminaryClassificationCertificate,
    featuresOfCustomsClearance,
    code,
    comments,
    notes,
    classification_comments,
    customsLaboratoris,
    description,
    dualUseGoods,
    duty,
    free_trade_zone_agreements,
    duty_sng,
    exciseDues,
    exciseDutyMarks,
    exportDues,
    exportDuesAdjust,
    fillingInstruction,
    licence,
    ondate,
    quota,
    shortDescription,
    tariffPreference,
    unitName,
    vat,
    to_date,
    id,
    parent,
    tnved,
    code14,
    direction,
    intellectual,
    parallel_import,
  }
}

function compactJson(json) {
  for (const prop in json) {
    if (json[prop] === null || json[prop] === undefined)
      delete json[prop];
  }
  return json;
}



// WEBPACK FOOTER //
// ./src/serializers/TnvedCode.js